const ACTIONVERIFY = {
	FETCH_VERRIFY_USER: 'FETCH_VERRIFY_USER'
};
const ACTIONBASEINFO = {
	FETCH_BASEINFO_CITYLIST: 'FETCH_BASEINFO_CITYLIST',
	SET_BASEINFO_CITYLIST: 'SET_BASEINFO_CITYLIST',
	FETCH_BASEINFO_DETAIL: 'FETCH_BASEINFO_DETAIL',
	SET_BASEINFO_DETAIL: 'SET_BASEINFO_DETAIL',
	FETCH_BASEINFO_SETDETAIL: 'FETCH_BASEINFO_SETDETAIL',
	FETCH_BASEINFO_WEIXINCONFIG: 'FETCH_BASEINFO_WEIXINCONFIG',
	FETCH_BASEINFO_WECHATTOKEN: 'FETCH_BASEINFO_WECHATTOKEN'
};
const ACTIONCOMMON = {
	FETCH_COMMON_UPLOAD: 'FETCH_COMMON_UPLOAD',
	FETCH_COMMON_HOMEPAGESTATUS: 'FETCH_COMMON_HOMEPAGESTATUS',
	SET_COMMON_HOMEPAGE: 'SET_COMMON_HOMEPAGE',
	FETCH_COMMON_SETSHOMEPAGESTATUS: 'FETCH_COMMON_SETSHOMEPAGESTATUS',
	FETCH_COMMON_SETDOMIANAME: 'FETCH_COMMON_SETDOMIANAME',
	FETCH_COMMON_AUTH: 'FETCH_COMMON_AUTH',
	SET_COMMON_AUTH: 'SET_COMMON_AUTH'
};
const ACTIONALBUM = {
	FETCH_ALBUM_LIST: 'FETCH_ALBUM_LIST',
	SET_ALBUM_LIST: 'SET_ALBUM_LIST',
	FETCH_ALBUM_UPDATE: 'FETCH_ALBUM_UPDATE'
};
const ADMIN = {
	SET_ADMINMAIN_LIST: 'SET_ADMINMAIN_LIST',
	FETCH_ADMINMAIN_LIST: 'FETCH_ADMINMAIN_LIST',
	ADD_PROMOTION_BRAND: 'ADD_PROMOTION_BRAND',
	EDIT_PROMOTION_BRAND: 'EDIT_PROMOTION_BRAND',
	DELETE_PROMOTION_BRAND: 'DELETE_PROMOTION_BRAND',
	ADD_PROMOTION_LEADER: 'ADD_PROMOTION_LEADER',
	EDIT_PROMOTION_LEADER: 'EDIT_PROMOTION_LEADER',
	DELETE_PROMOTION_LEADER: 'DELETE_PROMOTION_LEADER',
	ADD_PROMOTION_PRESS: 'ADD_PROMOTION_PRESS',
	EDIT_PROMOTION_PRESS: 'EDIT_PROMOTION_PRESS',
	DELETE_PROMOTION_PRESS: 'DELETE_PROMOTION_PRESS',
	GET_PROMOTION: 'GET_PROMOTION',
	SET_PROMOTION: 'SET_PROMOTION',
	POST_PROMOTION: 'POST_PROMOTION',
	PROMOTION_EDITED: 'PROMOTION_EDITED',
	FETCH_ADMIN_LIST: 'FETCH_ADMIN_LIST',
	SET_ADMIN_LIST: 'SET_ADMIN_LIST',
	FETCH_ADMIN_ADD: 'FETCH_ADMIN_ADD',
	FETCH_ADMIN_REMOVE: 'FETCH_ADMIN_REMOVE'
};
const ACITONCOPYRIGHT = {
	FETCH_COPYRIGHT_TOPICLIST: 'FETCH_COPYRIGHT_TOPICLIST',
	SET_COPYRIGHT_TOPICLIST: 'SET_COPYRIGHT_TOPICLIST',
	FETCH_COPYRIGHT_SPORTLIST: 'FETCH_COPYRIGHT_SPORTLIST',
	SET_COPYRIGHT_SPORTLIST: 'SET_COPYRIGHT_SPORTLIST',
	FETCH_COPYRIGHT_CAPTCHA: 'FETCH_COPYRIGHT_CAPTCHA',
	COPYRIGHT_BIND_PHONE: 'COPYRIGHT_BIND_PHONE',
	COPYRIGHT_BIND_PHONE_PC: 'COPYRIGHT_BIND_PHONE_PC',
	COPYRIGHT_GET_WXINFO: 'COPYRIGHT_GET_WXINFO',
	COPYRIGHT_LIST_BY_SECTIONID: 'COPYRIGHT_LIST_BY_SECTIONID',
	LOGOUT: 'LOGOUT',
	UPDATENICKNAME: 'UPDATENICKNAME',
	FETCH_ACTIVITY_CONTENT: 'FETCH_ACTIVITY_CONTENT',
	FETCH_ACTIVITY_DETAIL: 'FETCH_ACTIVITY_DETAIL',
	SET_ACTIVITY_CONTENT: 'SET_ACTIVITY_CONTENT',
	SET_COPYRIGHT_ACTIVITYIMGVALLFLAG: 'SET_COPYRIGHT_ACTIVITYIMGVALLFLAG',
	SET_ACTIVITY_DETAIL: 'SET_ACTIVITY_DETAIL',
	FETCH_PRIZE_LIST: 'FETCH_PRIZE_LIST',
	SET_PRIZE_LIST: 'SET_PRIZE_LIST',
	FETCH_UPLOAD_HISTORY: 'FETCH_UPLOAD_HISTORY',
	SET_UPLOAD_HISTORY: 'SET_UPLOAD_HISTORY',
	FETCH_USER_INFO: 'FETCH_USER_INFO',
	FETCH_COPYRIGHT_UPLOADIMG: 'FETCH_COPYRIGHT_UPLOADIMG',
	FETCH_COPYRIGHT_IMGINFO: 'FETCH_COPYRIGHT_IMGINFO',
	FETCH_COPYRIGHT_GALLERYIMGLIST: 'FETCH_COPYRIGHT_GALLERYIMGLIST',
	FETCH_COPYRIGHT_PRAISEIMGLIST: 'FETCH_COPYRIGHT_PRAISEIMGLIST',
	SET_COPYRIGHT_GALLERYIMGLIST: 'SET_COPYRIGHT_GALLERYIMGLIST',
	SET_COPYRIGHT_GALLERYIMGVALLFLAG: 'SET_COPYRIGHT_GALLERYIMGVALLFLAG',
	FETCH_COPYRIGHT_IDETAILIMGINFO: 'FETCH_COPYRIGHT_IDETAILIMGINFO',
	COPYRIGHT_AUTH_STATUS: 'COPYRIGHT_AUTH_STATUS',
	FETCH_COPYRIGHT_DOWNLOADQRCODE: 'FETCH_COPYRIGHT_DOWNLOADQRCODE',
	FETCH_COPYRIGHT_DOWNLOADINFO: 'FETCH_COPYRIGHT_DOWNLOADINFO',
	SET_ACTIVITYLIST_LIST: 'SET_ACTIVITYLIST_LIST',
	FETCH_COPYRIGHTHEAD_IMG: 'FETCH_COPYRIGHTHEAD_IMG',
	SET_COPYRIGHT_BASEINFO: 'SET_COPYRIGHT_BASEINFO',
	FETCH_GALLERYIMG_PRAISE: 'FETCH_GALLERYIMG_PRAISE',
	SET_GALLERYIMG_PRAISE: 'SET_GALLERYIMG_PRAISE',
	SET_GALLERYIMG_GALLERY: 'SET_GALLERYIMG_GALLERY',
	SET_GALLERYIMG_HOME: 'SET_GALLERYIMG_HOME',
	SET_GALLERYIMG_SEARCH: 'SET_GALLERYIMG_SEARCH',
	SET_GALLERYIMG_ACITIVIY: 'SET_GALLERYIMG_ACITIVIY',
	SET_COPYRIGHT_PRAISEIMGLIST: 'SET_COPYRIGHT_PRAISEIMGLIST',
	FETCH_UPLOAD_TOKEN: 'FETCH_UPLOAD_TOKEN',
	SET_UPLOAD_TOKENINFO: 'SET_UPLOAD_TOKENINFO',
	FETCH_UPLOAD_REDISKEY: 'FETCH_UPLOAD_REDISKEY',
	FETCH_SEARCH_TOUTUINFO: 'FETCH_SEARCH_TOUTUINFO',
	SET_SEARCH_TOUTUINFO: 'SET_SEARCH_TOUTUINFO',
	FETCH_TOPICCONFIG_LIST: 'FETCH_TOPICCONFIG_LIST',
	SET_TOPICCONIFG_LIST: 'SET_TOPICCONIFG_LIST',
	FETCH_BANNERCONFIG_LIST: 'FETCH_BANNERCONFIG_LIST',
	SET_BANNERCONIFG_LIST: 'SET_BANNERCONIFG_LIST',
	FETCH_ACTIVITYCONFIG_LIST: 'FETCH_ACTIVITYCONFIG_LIST',
	SET_ACTIVITYCONIFG_LIST: 'SET_ACTIVITYCONIFG_LIST',
	FETCH_PLACARDITEM_LIST: 'FETCH_PLACARDITEM_LIST',
	SET_PLACARDITEM_LIST: 'SET_PLACARDITEM_LIST',
	FETCH_COPYRIGHT_NEWSLIST: 'FETCH_COPYRIGHT_NEWSLIST',
	SET_COPYRIGHT_NEWSLIST: 'SET_COPYRIGHT_NEWSLIST',
	FETCH_COPYRIGHT_NEWSDETAIL: 'FETCH_COPYRIGHT_NEWSDETAIL',
	SET_COPYRIGHT_NEWSDETAIL: 'SET_COPYRIGHT_NEWSDETAIL',
	FETCH_COPYRIGHT_NEWSHISTORYLIST: 'FETCH_COPYRIGHT_NEWSHISTORYLIST',
	SET_COPYRIGHT_NEWSHISTORYLIST: 'SET_COPYRIGHT_NEWSHISTORYLIST',
	FETCH_COPYRIGHT_UPDATEREADNUM: 'FETCH_COPYRIGHT_UPDATEREADNUM',
	FETCH_COPYRIGHT_NEWSPRAISE: 'FETCH_COPYRIGHT_NEWSPRAISE',
	SET_COPYRIGHT_NEWSPRAISE: 'SET_COPYRIGHT_NEWSPRAISE',
	FETCH_COPYRIGHT_CANCELNEWSPRAISE: 'FETCH_COPYRIGHT_CANCELNEWSPRAISE',
	SET_COPYRIGHT_CANCELNEWSPRAISE: 'SET_COPYRIGHT_CANCELNEWSPRAISE',
	FETCH_COPYRIGHT_NEWSPRAISE_HOME: 'FETCH_COPYRIGHT_NEWSPRAISE_HOME',
	SET_COPYRIGHT_NEWSPRAISE_HOME: 'SET_COPYRIGHT_NEWSPRAISE_HOME',
	FETCH_COPYRIGHT_CANCELNEWSPRAISE_HOME: 'FETCH_COPYRIGHT_CANCELNEWSPRAISE_HOME',
	SET_COPYRIGHT_CANCELNEWSPRAISE_HOME: 'SET_COPYRIGHT_CANCELNEWSPRAISE_HOME',
};
const ACTIONREPORT = {
	FETCH_REPORT_DEMO: 'FETCH_REPORT_DEMO',
	SET_REPORT_DEMO: 'SET_REPORT_DEMO'
};
export { ACTIONCOMMON, ACTIONVERIFY, ADMIN, ACTIONBASEINFO, ACTIONALBUM, ACITONCOPYRIGHT, ACTIONREPORT };
